import { useMutation } from "@tanstack/react-query";
import client from "@/data/client";

export function useUpdateExerciseStatusMutation() {
  return useMutation(client.exercise.updateStatus);
}

export function useSaveExerciseProgressMutation() {
  return useMutation(client.exercise.saveProgress);
}
